export const SCOPE_3_CATEGORIES_KEYS = Object.freeze({
  purchasedGoodsAndServicesDto: "purchasedGoodsAndServicesDto",
  capitalGoods: "capitalGoods",
  fuelAndEnergyRelatedActivities: "fuelAndEnergyRelatedActivities",
  upstreamTransportationAndDistribution: "upstreamTransportationAndDistribution",
  wasteGeneratedInOperations: "wasteGeneratedInOperations",
  businessTravel: "businessTravel",
  employeeCommuting: "employeeCommuting",
  upstreamLeasedAssets: "upstreamLeasedAssets",
  downstreamTransportationAndDistribution: "downstreamTransportationAndDistribution",
  processingOfSoldProducts: "processingOfSoldProducts",
  useOfSoldProducts: "useOfSoldProducts",
  treatmentOfSoldProducts: "treatmentOfSoldProducts",
  downstreamLeasedAssets: "downstreamLeasedAssets",
  franchises: "franchises",
  investments: "investments"
});

export const SCOPE_3_CATEGORIES_SEQUENCE = [
  SCOPE_3_CATEGORIES_KEYS.purchasedGoodsAndServicesDto,
  SCOPE_3_CATEGORIES_KEYS.capitalGoods,
  SCOPE_3_CATEGORIES_KEYS.fuelAndEnergyRelatedActivities,
  SCOPE_3_CATEGORIES_KEYS.upstreamTransportationAndDistribution,
  SCOPE_3_CATEGORIES_KEYS.wasteGeneratedInOperations,
  SCOPE_3_CATEGORIES_KEYS.businessTravel,
  SCOPE_3_CATEGORIES_KEYS.employeeCommuting,
  SCOPE_3_CATEGORIES_KEYS.upstreamLeasedAssets,
  SCOPE_3_CATEGORIES_KEYS.downstreamTransportationAndDistribution,
  SCOPE_3_CATEGORIES_KEYS.processingOfSoldProducts,
  SCOPE_3_CATEGORIES_KEYS.useOfSoldProducts,
  SCOPE_3_CATEGORIES_KEYS.treatmentOfSoldProducts,
  SCOPE_3_CATEGORIES_KEYS.downstreamLeasedAssets,
  SCOPE_3_CATEGORIES_KEYS.franchises,
  SCOPE_3_CATEGORIES_KEYS.investments
];
